import {execute, POST, GET} from "@/api/index";





export const setToken = (token)=> execute({method:POST, route: `/firebase`, data: {token}})

export const sendNotification = (token)=> execute({method:POST, route: `/sendNotification`})

export const statusActivacion = (iccActivacion)=> execute({method:GET, route: `/statusActivacion/${iccActivacion}`}, false)